import React from 'react';
import styled from 'styled-components';
import { localize } from 'react-localize-redux';

import Avatar from 'components/ui/Avatar';
import { colors } from 'helpers/ColorHelper';
import constants from 'helpers/constants';

const StyledCard = styled.div`
  position: relative;
  padding: 1rem;
  display: flex;
  align-items: center;
  border-radius: 0.5rem;
  box-shadow: ${props => (props.hasUnreadMessages ? 'var(--box-shadow)' : 'none')};
  margin-bottom: 0.5rem;
  cursor: pointer;
  background-color: ${props => (props.isActive ? colors.LIGHT_BLUE_GREY : '#fff')};
  &::after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 1px;
    left: 0;
    bottom: -0.25rem;
    background-color: ${colors.LIGHT_GRAY};
  }
`;

const StyledAvatarContainer = styled.div`
  position: relative;
`;

const StyledUnreadMessagesIndicator = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 100%;
  background-color: ${colors.RED};
  position: absolute;
  left: 0;
  bottom: 0;
`;

const StyledConversationDetails = styled.div`
  width: calc(100% - 49px);
  padding: 0 1rem;
`;

const StyledUnitNumberP = styled.p`
  font-size: 1.125rem;
  font-weight: bold;
  margin: 0;
`;

const StyledDetailsP = styled.p`
  display: flex;
  justify-content: space-between;
  margin: 0;
`;

const StyledTenantNamesSpan = styled.span`
  color: ${colors.BLUEY_GREY};
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const StyledTypeSpan = styled.span``;

export const ConversationCard = localize()(
  ({ conversation, userType, isActive, translate, ...rest }) => {
    const hasUnreadMessages =
      userType === constants.userTypes.AGENT && !!conversation.landlord_unread_messages;
    const cotenantsName = conversation.cotenants.length > 0 && conversation.cotenants[0].name[0];
    const tenantType = conversation.is_for_active_lease
      ? translate('tenant')
      : translate('applicant');
    return (
      <StyledCard hasUnreadMessages={hasUnreadMessages} isActive={isActive} {...rest}>
        <StyledAvatarContainer>
          <Avatar text={cotenantsName} />
          {hasUnreadMessages && <StyledUnreadMessagesIndicator />}
        </StyledAvatarContainer>
        <StyledConversationDetails>
          {conversation.site_name && (
            <StyledUnitNumberP>{conversation.site_name}</StyledUnitNumberP>
          )}
          <StyledUnitNumberP>{conversation.name}</StyledUnitNumberP>
          <StyledDetailsP>
            <StyledTenantNamesSpan>
              {conversation.cotenants.map(c => c.name.split(' ')[0]).join(', ')}
            </StyledTenantNamesSpan>
            <StyledTypeSpan>{tenantType}</StyledTypeSpan>
          </StyledDetailsP>
        </StyledConversationDetails>
      </StyledCard>
    );
  }
);
